import { inject, InjectionKey } from '@vue/composition-api'

interface InboxMediaUrl {
  (url: string): string
}

interface InboxMediaConfig {
  host: string
}

export const inboxMediaUrl = (config: InboxMediaConfig) => (
  uri: string
): string => {
  return `${config.host}${uri}`
}

export const InboxMediaUrlKey: InjectionKey<InboxMediaUrl> = Symbol()

export const usingInboxMediaUrl = () => inject(InboxMediaUrlKey)
